import { useUpdatePropertyMutation } from '../../api';
import { useGetAccessToken } from '../auth/get-access-token.hook';

const useUpdateProperty = (options: any) => {
  const { headerWithAuth } = useGetAccessToken();
  const { mutate } = useUpdatePropertyMutation(headerWithAuth, options);

  return mutate;
};

export {
  useUpdateProperty,
};
